import { render, staticRenderFns } from "./SuspensionActions.vue?vue&type=template&id=1f9a8268&"
import script from "./SuspensionActions.vue?vue&type=script&lang=js&"
export * from "./SuspensionActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports